import React, { useEffect, useState } from 'react';
import 'slick-carousel/slick/slick.css'; 
import 'slick-carousel/slick/slick-theme.css';
import Aos from 'aos';
import 'aos/dist/aos.css';
import { useNavigate } from 'react-router-dom';

import carouselImage1 from '../assets/Home/Carousel/carousel1.jpg';
import carouselImage2 from '../assets/Home/Carousel/carousel2.jpg';
import carouselImage3 from '../assets/Home/Carousel/carousel3.jpg';
import carouselImage4 from '../assets/Home/Carousel/carousel4.jpg';
import sdImage from '../assets/Home/services/Software Development Logo.png';
import scImage from '../assets/Home/services/Software Consulting logo.png';
import aiImage from '../assets/Home/services/AI Logo.png';
import iotImage from '../assets/Home/services/IoT Logo.png';
import HealthCareImg from '../assets/Home/industries/Health Care Logo.png';
import insuranceImg from '../assets/Home/industries/Insurance Logo.png';
import ManufacturingImg from '../assets/Home/industries/manufacturing.jpg';
import ondemandImg from '../assets/Home/industries/On demand Logo.png';
import logisticsImg from '../assets/Home/industries/Logistics Logo.png';
import footprintImage from '../assets/Home/FootPrints.jpeg';

import HeroSection from '../components/Home/Hero';
import ServicesSection from '../components/Home/Hservices';
import IndustriesSection from '../components/Home/Hindustries';
import FootprintsSection from '../components/Home/Hfootprints';

import Preloader from '../ui/Preloader';

const services = [
  {
    id: "software-development",
    title: 'Software Development',
    image: sdImage,
    description:
      'Organically grow the holistic world view of disruptive innovation via workplace diversity and empowerment.',
  },
  {
    id: 'software-consulting',
    title: 'Software Consulting',
    image: scImage,
    description:
      'We help organizations across private, public, and social sectors create the Change that matters most to them.',
  },
  {
    id: 'artificial-intelligence',
    title: 'Artificial Intelligence',
    image: aiImage,
    description:
      'Empower your business today with our AI consulting and implement Artificial Intelligence models specific to your industry.',
  },
  {
    id:'iot',
    title: 'Internet of Things',
    image: iotImage,
    description:
      'We optimize IT services to make them more reliable and cost-effective and help introduce new IT services fast.',
  },
];

const carouselImages = [carouselImage1, carouselImage2, carouselImage3, carouselImage4];
const industryImages = {
  HealthCareImg,
  insuranceImg,
  ManufacturingImg,
  ondemandImg,
  logisticsImg,
};

const Home = () => {
  const [activeService, setActiveService] = useState(services[0]);
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    Aos.init({ duration: 1000, once: false });
  }, []);
  

  

  useEffect(() => {
    const delay = setTimeout(() => setLoading(false), 1200); 
    return () => clearTimeout(delay);
  }, []);


  return (
    <>
   { loading ? (<Preloader/>) : (<div className="w-full">
    <HeroSection navigate={navigate} carouselImages={carouselImages} />
    <ServicesSection
      services={services}
      activeService={activeService}
      setActiveService={setActiveService}
    />
    <IndustriesSection industryImages={industryImages} />
    <FootprintsSection footprintImage={footprintImage} />
  </div>)}
  </>
  );
};

export default Home;
